import * as Yup from "yup";
import { tr } from "yup-locales";
if (process.env.NEXT_PUBLIC_LANGUAGE !== "en") Yup.setLocale(tr); // en: Yup varsayilan (Ingilizce) mesajlari

export const PassengerShema = Yup.object().shape({
  name: Yup.string().required(),
  gender: Yup.boolean().required(),
  day: Yup.string()
    .matches(/0[1-9]|1[0-9]|2[0-9]|3[0-1]/)
    .required(),
  month: Yup.string()
    .matches(/0[1-9]|1[0-2]/)
    .required(),
  year: Yup.string()
    .matches(/^\d{4}$/)
    .required(),
  placeOfBirth: Yup.string().required(),
  tc: Yup.string().required(),
  isTurkish: Yup.boolean(),
});
